module.exports = __webpack_public_path__ + "img/download.766c842e.svg";